import React from 'react';
import * as fetcher from '@hydra/utils/fetcher';
import RumPageViewTable from '@hydra/routes/core-web-vitals/components/RumPageViewTable';
import { Card } from '@shopify/polaris';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  table: {
    border: 'none',
    paddingTop: 0,
    paddingBottom: 0,
    // Match Polaris Table Head visuals
    '& thead th > span': {
      fontSize: 12,
      fontWeight: 500
    },
    '& tbody th > *': {
      fontSize: 14
    }
  }
}));

export default function CWVPageView ({ apiKey, projectUrl }: {apiKey: string, projectUrl: string}) {
  const classes = useStyles();
  async function doFetch (url: string, limit: number) {
    return fetcher.get(`/shopify/rum-pages/${encodeURIComponent(url)}`, {
      searchParams: {
        limit: '5',
        daysAgo: '31',
        from: '0'
      },
      headers: {
        'x-api-key': apiKey
      }
    }).json();
  }
  return (
    <Card>
      <RumPageViewTable
        url={projectUrl}
        deviceType='all'
        disableHeading
        className={classes.table}
        fetchFunctionOverride={doFetch}
      />
    </Card>
  );
}
